/**
 * ENR-1613 "Take a Payment".
 * Enabled on all hosts (including production). Set
 * VITE_DIRECT_INVOICE_PAYMENT_UI_ENABLED=false to kill.
 */

export function resolveDirectInvoicePaymentUiEnabled(input?: {
  envOverride?: string;
}): boolean {
  const raw = (input?.envOverride ?? '').trim().toLowerCase();
  if (raw === 'false' || raw === '0') {
    return false;
  }
  if (raw === 'true' || raw === '1') {
    return true;
  }
  return true;
}

export const DIRECT_INVOICE_PAYMENT_UI_ENABLED =
  resolveDirectInvoicePaymentUiEnabled({
    envOverride: import.meta.env.VITE_DIRECT_INVOICE_PAYMENT_UI_ENABLED || '',
  });
